// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AirplaneIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AirplaneIcon" ref={forwardedRef} {...props}>
      <path d="m9.988 17.822 2.502.997h2l-2.256-4.613v-2.131l7.056 1.343v-2.161a1.7 1.7 0 0 0-.927-1.514l-6.129-3.128v-2.98a1 1 0 0 0-.179-.57l-1.01-1.455a1 1 0 0 0-.822-.43h-.45A1 1 0 0 0 8.96 1.602L7.92 3.063a1 1 0 0 0-.185.58v2.99l-6.098 3.11a1.7 1.7 0 0 0-.927 1.514v2.16l7.024-1.332v2.12L5.49 18.82h2zM7.85 17.168l1.284-2.64V3.77L9.98 2.58h.034l.82 1.181V14.53l1.29 2.636-2.136-.85zm4.44-8.953 5.436 2.775a.3.3 0 0 1 .164.267v.47l-5.6-1.067zm-4.58 2.45-5.6 1.062v-.47a.3.3 0 0 1 .164-.267L7.71 8.216z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AirplaneIcon = /* @__PURE__ */ Object.assign(
  AirplaneIconComponent,
  { displayName: 'AirplaneIcon' },
);
